import React from 'react';
import PropTypes from 'prop-types';
import styles from './ShareProduct.module.css';

const ShareProduct = ({ product }) => {
  const { productName, productBrand, thumbnailImage } = product;

  return (
    <div className={styles.container}>
      <img
        className={styles.thumbnail}
        src={thumbnailImage}
        alt={productName}
      />
      <div className={styles.name}>
        <p className={styles.brand}>{productBrand}</p>
        <p>{productName}</p>
      </div>
    </div>
  );
};

ShareProduct.propTypes = {
  product: PropTypes.shape({
    productName: PropTypes.string,
    productBrand: PropTypes.string,
    thumbnailImage: PropTypes.string,
  }).isRequired,
};

export default ShareProduct;
